import { userOptionsStore } from '~/shared/api'
import { TaxiparkCountryEnum } from '~/shared/config/enums'

const field = {
  RU: {
    phoneLength: 11,
    phoneMask: '+7 (###) ###-##-##',
    passportMask: '** ** ******',
  },
  CI: {
    phoneLength: 13,
    phoneMask: '+225 ##-##-###-###',
    passportMask: '** *******',
  },
}

export const getPhoneLengthByCountry = () => {
  const userCountry = userOptionsStore.country

  if (!userCountry) return field.RU.phoneLength

  return field[userCountry].phoneLength
}

export const getPhoneMaskByCountry = () => {
  const userCountry = userOptionsStore.country

  if (!userCountry) return ''

  return field[userCountry].phoneMask
}

export const getPassportMaskByCountry = (country?: string) => {
  const userCountry = userOptionsStore.country

  if (!userCountry) return ''

  if (!country) return field[userCountry].passportMask

  if (country && field[country as TaxiparkCountryEnum]?.passportMask)
    return field[country as TaxiparkCountryEnum].passportMask

  return ''
}
